export default __webpack_public_path__ + "static/media/penumetcha-raghava.63d3ff29.png";